import React, { FC } from 'react';

interface Props {
  className?: string;
  size: number;
}

export const CaroIcon: FC<Props> = ({ className, size }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 36 36"
    aria-hidden="true"
  >
    <g fill="none">
      <path d="M0 0h36v36H0z" />
      <path
        fill="#C2E2FF"
        d="M18 35.488c3.922 0 7.552-.743 10.509-2.872C33.046 29.348 36 24.019 36 18c0-9.941-8.059-18-18-18S0 8.059 0 18c0 6.025 2.96 11.36 7.506 14.626 2.955 2.124 6.578 2.862 10.494 2.862z"
      />
      <path
        fill="#192C55"
        d="M29 10.39a4 4 0 014 4V16a4 4 0 01-4 4v-9.61zm-22 0a4.13 4.13 0 00-4 4.26v1.06A4.14 4.14 0 007 20"
      />
      <path
        fill="#116DFF"
        d="M28.56 32.57a2 2 0 01-.26.18 17.94 17.94 0 01-18.09 1.47 17 17 0 01-2.51-1.48l-.26-.18a8.68 8.68 0 017.93-5.14h5.26a8.66 8.66 0 017.93 5.15z"
      />
      <path
        fill="#192C55"
        d="M16 23.16h4a1 1 0 011 1v3.45a3 3 0 01-6 0v-3.45a1 1 0 011-1z"
      />
      <rect width="26" height="18" x="5" y="6" fill="#116DFF" rx="6" />
      <path
        fill="#FDFDFD"
        d="M18 22a12.63 12.63 0 01-8.29-3.23 5.12 5.12 0 01-.62-7 4.59 4.59 0 016.67-.65 3.16 3.16 0 004.48 0 4.59 4.59 0 016.67.65 5.12 5.12 0 01-.62 7A12.63 12.63 0 0118 22z"
      />
      <circle cx="23.5" cy="14.5" r="1.8" fill="#192C55" />
      <circle cx="12.5" cy="14.5" r="1.8" fill="#192C55" />
      <path
        fill="#192C55"
        d="M18 19a6.25 6.25 0 01-3.47-1l.55-.84a5.22 5.22 0 005.84 0l.55.84A6.25 6.25 0 0118 19zm5.32-12.87l-3.68 2.21c-1.01.6-2.27.6-3.28 0l-3.68-2.21A3.83 3.83 0 0116.12 4h3.76a3.83 3.83 0 013.44 2.13zM18 33.77a6.32 6.32 0 01-6.32-5.69l1-.1a5.36 5.36 0 0010.66 0l1 .1A6.33 6.33 0 0118 33.77z"
      />
    </g>
  </svg>
);
